<template>
  <div class="footer">
    <div class="container">
        <p>© 香草终端</p>
        <p>版本号：1.0.0(内测)</p>
    </div>
  </div>
</template>

<script lang="ts" setup>

</script>

<style lang="scss" scoped>
    .footer{
        width: 100%;height: 40px;background: var(--bg2_color);box-shadow: 0px 2px 4px 1px rgba(0,0,0,0.16);
        .container{
            display: flex;justify-content: space-between;align-items: center;
            p{
                font-family: 'Noto Sans SC, Noto Sans SC';font-weight: 500;font-size: 14px;color: var(--font_color2);line-height: 40px;
            }
        }
    }
</style>
